import React from 'react';
import {
  DtpTable,
  DtpTableHeader,
} from 'dtp-react-components';
import PropTypes from 'prop-types';

const Table = (props) => {
  const tableHeader = props.listaTableHeader.map((item, i) => (
    <DtpTableHeader
      dataField={item.id}
      dataAlign={item.dataAlign ? item.dataAlign : 'center'}
      width={item.width ? item.width : ''}
      isKey={i === 0}
      header={item.label}
      dataFormat={item.dataFormat}
      // width={i === 0 ? 200 : 120}
    />
  ));

  return (
    <DtpTable {...props}>
      {tableHeader}
    </DtpTable>
  );
};
Table.propTypes = {
  /** Lista contendo ids e nome dos atributos a serem mostrados na tabela */
  listaTableHeader: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Table.jsx